<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("basic-zoning-plan") }}
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("basic-zoning-plan") }}
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section300" field="ALPHA_PRI" :label="$t('alpha-pri')">
                <div>{{ $t("alpha-pri") }}</div>
                <div>
                  <ul class="list-plot-lists">
                    <li v-for="(item, index) in plotItem.ALPHA_PRI_META" :key="index">
                      {{ item.value }}
                      <div v-if="item.area || item.pro">[ {{ item.area }}m² / {{ item.pro }}% ]</div>
                    </li>
                  </ul>
                </div>
              </TooltipTR>
              <TooltipTR section="section300" field="ALPHA_SEC" :label="$t('alpha-sec')">
                <div>{{ $t("alpha-sec") }}</div>
                <div>
                  <ul class="list-plot-lists">
                    <li v-for="(item, index) in plotItem.ALPHA_SEC_META" :key="index">
                      {{ item.value }}
                      <div v-if="item.area || item.pro">[ {{ item.area }}m² / {{ item.pro }}% ]</div>
                    </li>
                  </ul>
                </div>
              </TooltipTR>
              <TooltipTR section="section300" field="ALPHA" :label="$t('alpha-ter')">
                <div>{{ $t("alpha-ter") }}</div>
                <div>
                  <ul class="list-plot-lists">
                    <li v-for="(item, index) in plotItem.ALPHA_TER_META" :key="index">
                      {{ item.value }}
                      <div v-if="item.area || item.pro">[ {{ item.area }}m² / {{ item.pro }}% ]</div>
                    </li>
                  </ul>
                </div>
              </TooltipTR>
              <TooltipTR section="section300" field="ZONE_BAU"  :label="$t('zone-bau')">
                <div>{{ $t("zone-bau") }}</div>
                <div>
                  <ul class="list-plot-lists">
                    <li v-for="(item, index) in plotItem['ZONE_BAUS']" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </TooltipTR>
              <TooltipTR section="section300" field="kA"  :label="$t('kA')">
                <div>{{ $t("kA") }}</div>
                <div>{{ plotItem.kA != null ? plotItem.kA : "-" }}</div>
              </TooltipTR>
              <TooltipTR section="section300" field="gA" :label="$t('gA')">
                <div>{{ $t("gA") }}</div>
                <div>{{ plotItem.gA != null ? plotItem.gA : "-" }}</div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  get isAlphaPrisArray() {
    return Array.isArray(this.plotItem.ALPHA_PRIS)
  }
  get isAlphaSecArray() {
    return Array.isArray(this.plotItem.ALPHA_SECS)
  }
  get isAlphaTerArray() {
    return Array.isArray(this.plotItem.ALPHA_TERS)
  }

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section300")) || {}
  }

}
</script>
